var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heart_box",on:{"click":_vm.likeMember}},[(_vm.isMyLike())?_c('img',{attrs:{"src":require("@/assets/image/s_heart_color.png")}}):_c('img',{attrs:{"src":require("@/assets/image/s_heart.png")}}),_c('span',[_vm._v(_vm._s(_vm.returnCommas(_vm.likeData.likeCnt)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }